import { swrFetch } from 'src/utils/swrFetch';
import { Period } from 'src/models/EnergyResponse';
import useSWR from 'swr';

export const useReference = (id: number) => {
    return useSWR<Period[]>(`/objects/${id}/reference-periods`, swrFetch, {
        suspense: false,
    });
};
